import { VideoOff } from 'lucide-react'

/**
 * Kachel mit dem Livebild einer Drohne (HLS-Player von MediaMTX im iframe, funktioniert in Chrome und Safari/iPad).
 * Wiederverwendbar für die Externe-Seite (Freigabelink) und später die Videowand.
 * `fuellen`: Kachel füllt die vorgegebene Höhe (Wandmodus auf großen Bildschirmen) statt 16:9 festzuhalten; `gross`: große Schrift.
 */
export function StreamKachel({ titel, untertitel, url, className = '', fuellen = false, gross = false, farbe }: {
  titel: string
  untertitel?: string
  url: string | null
  className?: string
  fuellen?: boolean
  gross?: boolean
  farbe?: string
}) {
  return (
    <div className={`overflow-hidden rounded-xl border border-dark-border bg-dark-bg-secondary ${fuellen ? 'flex h-full min-h-0 flex-col' : ''} ${className}`}>
      <div className={`relative w-full bg-black ${fuellen ? 'min-h-0 flex-1' : 'aspect-video'}`}>
        {url ? (
          <iframe src={url} title={`Livebild ${titel}`} className="absolute inset-0 h-full w-full" allow="autoplay; fullscreen" allowFullScreen />
        ) : (
          <div className={`absolute inset-0 flex flex-col items-center justify-center gap-1 text-dark-text-muted ${gross ? 'text-2xl' : 'text-sm'}`}>
            <VideoOff className={gross ? 'h-12 w-12' : 'h-6 w-6'} />
            Kein Livebild
          </div>
        )}
      </div>
      <div className={`flex shrink-0 items-baseline justify-between gap-2 ${gross ? 'px-4 py-3' : 'px-3 py-2'}`}>
        <span className={`flex min-w-0 items-center gap-2 font-semibold text-dark-text ${gross ? 'text-2xl' : 'text-sm'}`}>
          {farbe && <span className={`inline-block shrink-0 rounded-full ${gross ? 'h-4 w-4' : 'h-2.5 w-2.5'}`} style={{ background: farbe }} />}
          <span className="truncate">{titel}</span>
        </span>
        {untertitel && <span className={`shrink-0 text-dark-text-muted ${gross ? 'text-xl' : 'text-xs'}`}>{untertitel}</span>}
      </div>
    </div>
  )
}
